import { render, staticRenderFns } from "./customs-declaration.vue?vue&type=template&id=2ed3c968&scoped=true"
import script from "./customs-declaration.vue?vue&type=script&lang=ts"
export * from "./customs-declaration.vue?vue&type=script&lang=ts"
import style0 from "./customs-declaration.vue?vue&type=style&index=0&id=2ed3c968&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed3c968",
  null
  
)

export default component.exports